export default __webpack_public_path__ + "static/media/bvp_logo.4fe08a74.jpeg";